import { useHistory } from "react-router-dom";
import "./CommonBannerComponent.scss";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import axios from "axios";
import { url_83, url_213 } from "../../../../../custom_utilities/api_services";
import { useEffect, useState } from "react";
import userActivityActions from "../../../../../redux/user_activity/action";

const getPackageId = (data = {}) =>
  data.package_id ??
  data.buy_package_id ??
  data.packageId ??
  data.package_details?.package_id ??
  data.package_detail?.package_id;

const isCpsTab = (tab) =>
  tab === "/cps" || tab === "cps" || tab === "/adaptive_cps" || tab === "adaptive_cps";

const CommonBannerComponent = (props) => {
  let { tab, userPreference, startLoading, finishLoading, setCommonBannerData } =
    props;

  const [state, setState] = useState({
    data: {},
  });

  useEffect(() => {
    if (!userPreference?.courseDetails?.length) return;
    getAttemptDetails();
  }, [userPreference?.courseDetails?.[0]?.course_id]);

  const getPaperType = () => {
    const tabToPaperType = {
      adaptive_cps: 4,
      "/adaptive_cps": 4,
      cps: 2,
      "/cps": 2,
      "Exam Cracker - JEE Main": 9,
      "Exam Cracker - JEE Advanced": 8,
      "Exam Cracker - NEET": 6,
    };
    return tabToPaperType[tab];
  };

  const getAttemptDetails = async () => {
    const { courseDetails, classDetails } = userPreference || {};
    const courseId = courseDetails?.[0]?.course_id;
    const classId = classDetails?.class_id;
    const paperType = getPaperType();

    const query = new URLSearchParams({
      paper_type: paperType,
    });
    if (courseId) query.set("course_id", courseId);
    if (classId) query.set("class_id", classId);

    startLoading();
    try {
      const response = await axios.get(`${url_213}/?${query.toString()}`);
      if (response.data.status === 200) {
        let attemptData = response.data.data || {};

        if (!getPackageId(attemptData) && courseId && classId) {
          const subjectResponse = await axios.post(url_83, {
            course_id: courseId,
            class_id: classId,
          });
          if (subjectResponse.data?.status === 200) {
            const packageId = getPackageId(subjectResponse.data.data);
            if (packageId) {
              attemptData = { ...attemptData, package_id: packageId };
            }
          }
        }

        finishLoading();
        setState((prevState) => ({
          ...prevState,
          data: attemptData,
        }));
        setCommonBannerData({
          data: attemptData,
        });
      } else {
        finishLoading();
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };

  const history = useHistory();

  const width = tab.includes("Exam Cracker") ? "68%" : "100%";

  const handleButtonClick = () => {
    const packageId = getPackageId(state.data);
    if (isCpsTab(tab) && packageId) {
      history.push(`/package/${packageId}`);
      return;
    }
    history.push({ pathname: "/store", state: { tab: "online_learning" } });
  };

  return (
    <>
      {tab.includes("Exam Cracker") && !state.data.package_active && (
        <div
          className="common_promo_banner d-flex align-items-center"
          style={{ width: width, margin: "auto" }}
        >
          <div>
            <p>Exam Mastery</p>
            <p>
              Your path to exam success begins with ‘Exam Cracker’. <br />
              Subscribe now!
            </p>
          </div>
          <div>
            <button onClick={handleButtonClick}>Buy Now</button>
          </div>
        </div>
      )}
      {isCpsTab(tab) && !state.data.package_active && (
          <div className="common_promo_banner d-flex align-items-center">
            <div>
              {state.data.is_attempt > 0 ? (
                <>
                  <p>Enjoy your Free Trial attempts</p>
                  <span>{state.data.is_attempt} Left</span>
                </>
              ) : (
                <p>No free attempts left</p>
              )}
              {tab === "/cps" || tab === "cps" ? (
                <p>
                  Upgrade now for unlimited access and unlock the full potential
                  of Conceptual Problem Sheets.
                </p>
              ) : (
                <p>
                  Upgrade now for unlimited access and unlock the full potential
                  of Adaptive CPS.
                </p>
              )}
            </div>
            <div>
              <button onClick={handleButtonClick}>Get Now</button>
            </div>
          </div>
        )}
    </>
  );
};

const mapStateToProps = (state) => ({
  userPreference: state.userPreference,
});

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setCommonBannerData: (payload) => {
      dispatch(userActivityActions.setCommonBannerData(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonBannerComponent);
